<template>
  <span>
    <i
      v-if="taskStatus === TASK_STATUS.CHO_PHE_DUYET_DK"
      class="fas fa-clock color__blue icon-status icon-CHOPHEDUYET"
    ></i>
    <i
      v-if="taskStatus === TASK_STATUS.HOAN_THANH"
      class="fas fa-check-circle color__green icon-status icon-HOANTHANH"
    ></i>
    <i
      v-if="taskStatus === TASK_STATUS.DANG_THUC_HIEN"
      class="fas fa-play-circle color__yellow icon-status icon-DANGTRIENKHAI"
    ></i>
    <i
      v-if="
        taskStatus === TASK_STATUS.HUY ||
          taskStatus === TASK_STATUS.TAM_DUNG ||
          taskStatus === TASK_STATUS.HUY_PHE_DUYET_DK
      "
      class="fas fa-times-circle color__red icon-status icon-HUY"
    ></i>
    <i
      v-if="taskStatus === TASK_STATUS.KET_THUC"
      class="fas fa-check-double color__blue icon-status icon-KETTHUC"
    ></i>
  </span>
</template>
<script>
import constants from "../../constants";

export default {
  name: "taskStatusIcon",
  props: ["taskStatus"],
  data() {
    return {
      TASK_STATUS: constants.TASK_STATUS
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/views/job/task-status-icon.vue